import _ from "lodash";
import { transformPostSlidePreproccedSlideToPostSlide } from "../../functions/transformFunctions";
import { PostBlockSlide, SlideTypes, WPPostBlockSlide, WPSlide } from "../../types/Slides";
import { PostSlidePreprocessed } from "../../types/transformedType";
import { getGlobalSlideData } from "../useProcessWordpressSlides";

export function transformPostBlockSlide(posts: PostSlidePreprocessed[], slide: WPSlide<WPPostBlockSlide>): PostBlockSlide[] {
  const acfSlide = slide.acf;
  const resPosts = posts
    .filter((post) => {
      const category = acfSlide[SlideTypes.POSTBLOCK].category;
      if (category == null || typeof category == 'string') return false;
      return category?.some((blockCategory) => post.cateogries.map((i) => i.categoryId).includes(blockCategory));
    })
    .map((post) => {
      return transformPostSlidePreproccedSlideToPostSlide(
        post,
        acfSlide[SlideTypes.POSTBLOCK].category as number[],
        acfSlide[SlideTypes.POSTBLOCK].standardImageLength,
        acfSlide[SlideTypes.POSTBLOCK].standardLength
      );
    });

  return [
    {
      type: SlideTypes.POSTBLOCK,
      categoryId: acfSlide[SlideTypes.POSTBLOCK].category as number[],
      slides: _.shuffle(resPosts),
      ...getGlobalSlideData(slide)
    }
  ];
}